import { PaletteMode } from '@mui/material';
import { useMediaQuery } from '@mui/system';
import { useEffect, useState } from 'react';
import { Themes } from 'routes/Profile/Profile';

function getMode(isDark: boolean) {
  return !localStorage.getItem('theme')
    ? isDark
      ? Themes.DARK
      : Themes.LIGHT
    : (localStorage.getItem('theme') as PaletteMode) ?? Themes.LIGHT;
}

export default function useThemeSwitch() {
  const isDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const initialMode = getMode(isDarkMode);

  const [mode, setMode] = useState<PaletteMode>(initialMode);

  useEffect(() => {
    window.addEventListener('storage', () => {
      const theme = getMode(isDarkMode);
      setMode(theme);
    });

    return () => {
      window.removeEventListener('storage', () => {
        const theme = getMode(isDarkMode);
        setMode(theme);
      });
    };
  }, [isDarkMode]);

  return mode;
}
